import { round } from 'lodash';

export const toPercents = (value: $TSFixMe, precision = 0) => round(value * 100, precision);
